
class FookizHeader extends HTMLElement {
    constructor() {
        super();
        this.lastScroll = 0;
        this.checkScroll = this.checkScroll.bind(this);
    }

    connectedCallback() {
        window.addEventListener("scroll", this.checkScroll);
        this.checkScroll();
    }

    disconnectedCallback() {
        window.removeEventListener("scroll", this.checkScroll);
    }

    checkScroll() {
        let currentScroll = window.pageYOffset;

        if (currentScroll <= 48) {
        this.classList.add("transparent");
        this.classList.remove("scrolled");
    } else {
        this.classList.remove("transparent");
        this.classList.add("scrolled");
    }
        if (currentScroll > this.lastScroll && currentScroll > 100) {
        this.classList.add("hide");
    } else {
        this.classList.remove("hide");
    }

        this.lastScroll = currentScroll;
    }
}

customElements.define("fookiz-header", FookizHeader);
